module.exports = __webpack_public_path__ + "media/images/games/35gender/firefighter-f25f49c500b27433509b877e15428e36.png";